import * as React from "react"
import { Label as LabelPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "tw:flex! tw:items-center! tw:gap-2! tw:text-xs/relaxed! tw:leading-none tw:font-medium tw:select-none! tw:group-data-[disabled=true]:pointer-events-none! tw:group-data-[disabled=true]:opacity-50! tw:peer-disabled:cursor-not-allowed! tw:peer-disabled:opacity-50!",
        className
      )}
      {...props}
    />
  )
}

export { Label }
